import React, { useLayoutEffect, useRef, useState } from "react";
import { MARQUEE } from "../data/shop";
import { Zia } from "./Zia";
import "./Marquee.css";

/** Seconds for one list to travel its own width — keeps speed constant. */
const SECONDS_PER_LIST = 34;

const Words = () => (
  <>
    {MARQUEE.map((word) => (
      <span className="marquee__item" key={word}>
        <Zia size={12} className="marquee__mark" />
        {word}
      </span>
    ))}
  </>
);

export const Marquee = () => {
  const bannerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);
  const [copies, setCopies] = useState(1);

  // One list is narrower than a desktop viewport, so at the loop point the
  // right side would sit empty. Repeat the list until a track is at least as
  // wide as the banner.
  useLayoutEffect(() => {
    const banner = bannerRef.current;
    const list = listRef.current;
    if (!banner || !list) return;

    const measure = () => {
      const listWidth = list.getBoundingClientRect().width;
      if (!listWidth) return;
      const needed = Math.ceil(banner.getBoundingClientRect().width / listWidth);
      setCopies(Math.max(1, needed));
    };

    measure();

    // Watches the banner for viewport changes and the list for late font swaps.
    const observer = new ResizeObserver(measure);
    observer.observe(banner);
    observer.observe(list);
    return () => observer.disconnect();
  }, []);

  const track = (trackIndex: number) => (
    <div
      className="marquee__track"
      style={{ animationDuration: `${copies * SECONDS_PER_LIST}s` }}
      /* Only the very first list is read out; the rest are visual repeats. */
      aria-hidden={trackIndex > 0 ? true : undefined}
    >
      {Array.from({ length: copies }, (_, listIndex) => (
        <div
          className="marquee__list"
          key={listIndex}
          ref={trackIndex === 0 && listIndex === 0 ? listRef : undefined}
          aria-hidden={trackIndex === 0 && listIndex === 0 ? undefined : true}
        >
          <Words />
        </div>
      ))}
    </div>
  );

  return (
    <div className="marquee" ref={bannerRef}>
      {track(0)}
      {/* duplicate track keeps the scroll seamless */}
      {track(1)}
    </div>
  );
};
